export class SituacaoFrequenciaAcao {
    situacao: any[] = [
        {tipo: 'FALTOU', flag: 'N'},
        {tipo: 'PARTICIPOU DA ATIVIDADE', flag: 'S'}
    ];

    getSituacaoFrequenciaAcao(flag: string) {
        const situacao = this.situacao.find(d => d.flag.includes(flag));
        return situacao ? situacao.tipo : null;
    }
}
